function openSizeChartDrawer() {
  document.getElementById("drawer-size-chart").classList.add("open");
}

function closeSizeChartDrawer() {
  document.getElementById("drawer-size-chart").classList.remove("open");
}

// Close drawer when clicking outside the content
document.addEventListener("click", function (event) {
  const drawer = document.getElementById("drawer-size-chart");
  if (drawer.classList.contains("open") && !drawer.contains(event.target) && !event.target.closest("button")) {
    closeSizeChartDrawer();
  }
});